"use client";
// components/iraq/GuyanaClientWrapper.jsx
import dynamic from "next/dynamic";

// ssr: false is only allowed inside Client Components ("use client")
const GuyanaClient = dynamic(
  () => import("@/components/iraq/GuyanaClient"),
  { ssr: false }
);

export default function GuyanaClientWrapper({ initialContent }) {
  return <GuyanaClient initialContent={initialContent} />;
}